(function () {
  const root = document.querySelector('[data-fxp-webinar]');
  if (!root || root.dataset.fxpInitialized === 'true') return;
  root.dataset.fxpInitialized = 'true';

  const form = root.querySelector('[data-fxp-form]');
  if (!form) return;

  const fallbackZones = [
    'Europe/Nicosia','Asia/Manila','Europe/London','Europe/Paris','Europe/Berlin','Europe/Helsinki','Europe/Moscow',
    'America/Los_Angeles','America/Denver','America/Phoenix','America/Chicago','America/New_York','America/Toronto',
    'America/Vancouver','America/Sao_Paulo','America/Argentina/Buenos_Aires','America/Mexico_City','America/Bogota',
    'Africa/Cairo','Africa/Johannesburg','Africa/Lagos','Asia/Jerusalem','Asia/Riyadh','Asia/Dubai','Asia/Karachi',
    'Asia/Kolkata','Asia/Dhaka','Asia/Bangkok','Asia/Jakarta','Asia/Singapore','Asia/Hong_Kong','Asia/Shanghai',
    'Asia/Tokyo','Asia/Seoul','Australia/Perth','Australia/Adelaide','Australia/Brisbane','Australia/Sydney',
    'Pacific/Auckland','Pacific/Honolulu','UTC'
  ];
  const timezoneSelects = Array.from(root.querySelectorAll('[data-fxp-timezone]'));
  const countrySelects = Array.from(root.querySelectorAll('[data-fxp-country]'));
  const eventTimeNode = root.querySelector('[data-fxp-event-time]');
  const eventDateNode = root.querySelector('[data-fxp-event-date]');
  const eventZoneNode = root.querySelector('[data-fxp-event-zone]');
  const workerUrl = (root.dataset.webhookUrl || '').trim();
  const successRedirectUrl = (root.dataset.successRedirectUrl || '').trim();
  const messageNode = root.querySelector('[data-fxp-message]');
  const submitButton = root.querySelector('[data-fxp-submit]');
  const roleInputs = Array.from(root.querySelectorAll('[data-fxp-role]'));
  const roleFields = Array.from(root.querySelectorAll('[data-fxp-fields]'));
  const roleError = root.querySelector('[data-fxp-role-error]');
  const attendanceInputs = Array.from(root.querySelectorAll('[data-fxp-attendance]'));
  const consentInput = root.querySelector('[data-fxp-consent]');
  const startedAtInput = root.querySelector('[data-fxp-started-at]');
  const honeypotInput = root.querySelector('[data-fxp-honeypot]');
  if (startedAtInput) startedAtInput.value = String(Date.now());

  function validTimeZone(zone) {
    try { new Intl.DateTimeFormat('en', { timeZone: zone }); return true; } catch (_) { return false; }
  }
  function detectTimeZone() {
    try {
      const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (zone && validTimeZone(zone)) return zone;
    } catch (_) {}
    return 'Europe/Nicosia';
  }
  function getTimeZones() {
    let zones = [];
    try {
      if (typeof Intl.supportedValuesOf === 'function') zones = Intl.supportedValuesOf('timeZone');
    } catch (_) {}
    if (!zones.length) zones = fallbackZones.slice();
    zones = Array.from(new Set(zones.concat(['Europe/Nicosia', 'Asia/Manila', 'UTC']))).filter(validTimeZone);
    return zones;
  }
  function getOffsetLabel(date, zone) {
    try {
      const part = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'longOffset' }).formatToParts(date).find(p => p.type === 'timeZoneName');
      const raw = part ? part.value : 'GMT';
      if (raw === 'GMT' || raw === 'UTC') return 'UTC+00:00';
      return raw.replace(/^GMT/, 'UTC');
    } catch (_) { return ''; }
  }
  function wallTimeToUtc(year, monthIndex, day, hour, minute, zone) {
    const target = Date.UTC(year, monthIndex, day, hour, minute, 0);
    let guess = target;
    // Iteratively reconcile the target wall-clock time with Intl's timezone-aware
    // rendering. This uses IANA rules (including DST), not a hard-coded offset.
    for (let i = 0; i < 6; i += 1) {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date(guess));
      const values = {};
      parts.forEach(part => { values[part.type] = part.value; });
      const shownAsUtc = Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), Number(values.hour), Number(values.minute), Number(values.second));
      const delta = target - shownAsUtc;
      guess += delta;
      if (delta === 0) break;
    }
    return new Date(guess);
  }
  const eventInstant = wallTimeToUtc(2026, 9, 25, 20, 0, 'Europe/Nicosia');
  let activeZone = detectTimeZone();
  function zoneDisplayName(zone) {
    return zone.replace(/_/g, ' ');
  }
  function selectedWebinarSchedule() {
    const zone = validTimeZone(activeZone) ? activeZone : 'Europe/Nicosia';
    const date = new Intl.DateTimeFormat('en-GB', {
      timeZone: zone, weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
    }).format(eventInstant);
    const time = new Intl.DateTimeFormat('en-US', {
      timeZone: zone, hour: 'numeric', minute: '2-digit'
    }).format(eventInstant);
    const offset = getOffsetLabel(eventInstant, zone);
    return date + ' · ' + time + ' · ' + zone + (offset ? ' (' + offset + ')' : '');
  }
  function renderEventTime() {
    if (!validTimeZone(activeZone)) activeZone = 'Europe/Nicosia';
    const dateText = new Intl.DateTimeFormat('en-GB', {
      timeZone: activeZone, weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
    }).format(eventInstant);
    const timeText = new Intl.DateTimeFormat('en-US', {
      timeZone: activeZone, hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
    }).format(eventInstant);
    if (eventTimeNode) eventTimeNode.textContent = timeText.replace(/\s+(GMT|UTC)([+-]\d+)/, ' $1$2');
    if (eventDateNode) eventDateNode.textContent = dateText;
    if (eventZoneNode) eventZoneNode.textContent = zoneDisplayName(activeZone) + ' · ' + getOffsetLabel(eventInstant, activeZone);
    timezoneSelects.forEach(select => { if (select.value !== activeZone) select.value = activeZone; });
  }
  function fillTimeZoneSelect(select) {
    if (!select) return;
    const zones = getTimeZones();
    const selected = activeZone;
    const rows = zones.map(zone => ({
      zone,
      offset: getOffsetLabel(eventInstant, zone),
      minutes: (() => {
        const label = getOffsetLabel(eventInstant, zone).replace('UTC', '').trim();
        const m = label.match(/^([+-])(\d{2}):(\d{2})$/);
        if (!m) return 0;
        return (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3]));
      })()
    })).sort((a,b) => a.minutes - b.minutes || a.zone.localeCompare(b.zone));
    select.replaceChildren();
    rows.forEach(row => {
      const option = document.createElement('option');
      option.value = row.zone;
      option.textContent = row.zone + (row.offset ? ' (' + row.offset + ')' : '');
      select.appendChild(option);
    });
    if (!zones.includes(selected)) {
      const option = document.createElement('option');
      option.value = selected;
      option.textContent = selected + ' (' + getOffsetLabel(eventInstant, selected) + ')';
      select.appendChild(option);
    }
    select.value = selected;
  }
  timezoneSelects.forEach(fillTimeZoneSelect);
  renderEventTime();
  timezoneSelects.forEach(select => {
    select.addEventListener('change', () => {
      if (validTimeZone(select.value)) activeZone = select.value;
      timezoneSelects.forEach(other => { other.value = activeZone; });
      renderEventTime();
    });
  });

  function selectedRole() {
    const checked = roleInputs.find(input => input.checked);
    return checked ? checked.value : '';
  }
  function activateRole(role, clearPrevious) {
    roleFields.forEach(fieldset => {
      const fieldType = fieldset.dataset.fxpFields;
      // Player details are required for player registrations and for parents applying on a player's behalf.
      const isCurrent = role === 'parent'
        ? (fieldType === 'parent' || fieldType === 'player')
        : role === 'player'
          ? fieldType === 'player'
          : false;
      if (!isCurrent && clearPrevious && !fieldset.hidden) {
        fieldset.querySelectorAll('input, textarea, select').forEach(control => {
          if (control.type === 'checkbox' || control.type === 'radio') control.checked = false;
          else if (control.tagName === 'SELECT') control.selectedIndex = 0;
          else control.value = '';
        });
      }
      fieldset.hidden = !isCurrent;
      fieldset.querySelectorAll('[data-fxp-required]').forEach(control => {
        control.required = isCurrent;
        if (!isCurrent) control.setCustomValidity('');
      });
    });
    if (roleError) roleError.hidden = true;
    roleInputs.forEach(input => {
      const card = input.closest('.fxp-role-option');
      if (card) card.setAttribute('aria-checked', input.checked ? 'true' : 'false');
    });
  }
  roleInputs.forEach(input => input.addEventListener('change', () => activateRole(input.value, true)));
  activateRole(selectedRole(), false);

  function showMessage(text, kind) {
    if (!messageNode) return;
    messageNode.hidden = false;
    messageNode.classList.toggle('fxp-form-message--error', kind === 'error');
    messageNode.textContent = text;
  }
  function populateCountrySelects() {
    if (!countrySelects.length) return;
    let countries = [];
    try {
      if (typeof window.intlTelInput === 'function' && typeof window.intlTelInput.getCountryData === 'function') {
        countries = window.intlTelInput.getCountryData().map(country => ({ name: String(country.name || '').replace(/\s*\(.+\)\s*$/, ''), iso2: country.iso2 || '' }));
      }
    } catch (_) { countries = []; }
    if (!countries.length) countries = ['Australia','Austria','Belgium','Brazil','Canada','Cyprus','Denmark','Egypt','Finland','France','Germany','Ghana','Greece','India','Ireland','Italy','Japan','Kenya','Netherlands','New Zealand','Nigeria','Norway','Philippines','Poland','Portugal','Singapore','South Africa','Spain','Sweden','Switzerland','United Arab Emirates','United Kingdom','United States'].map(name => ({ name, iso2: '' }));
    countries = countries.filter(country => country.name).sort((a, b) => a.name.localeCompare(b.name));
    countrySelects.forEach(select => { const selected = select.value; select.replaceChildren(new Option('Select your country', '')); countries.forEach(country => select.appendChild(new Option(country.name, country.name))); select.value = selected; });
  }
  function getPhoneInstance(input) {
    return input && input._fxpIti ? input._fxpIti : null;
  }
  async function normalizePhone(input) {
    const iti = getPhoneInstance(input);
    if (iti) {
      try { if (iti.promise && typeof iti.promise.then === 'function') await iti.promise; } catch (_) {}
      try {
        if (typeof iti.isValidNumber === 'function' && !iti.isValidNumber()) {
          input.setCustomValidity('Enter a valid WhatsApp number, including the correct country code.');
          return '';
        }
        const number = iti.getNumber();
        if (number) { input.setCustomValidity(''); return number.replace(/[\s().-]/g, ''); }
      } catch (_) {}
    }
    const raw = String(input && input.value || '').trim().replace(/[\s().-]/g, '');
    if (/^\+[1-9]\d{7,14}$/.test(raw)) { input.setCustomValidity(''); return raw; }
    if (input) input.setCustomValidity('Choose a country and enter a valid WhatsApp number.');
    return '';
  }
  function initializePhoneInputs() {
    const phoneInputs = Array.from(root.querySelectorAll('.fxp-phone-input'));
    if (typeof window.intlTelInput !== 'function') return;
    let languageRegion = '';
    try { languageRegion = (navigator.language || '').split('-')[1].toLowerCase(); } catch (_) {}
    const tzCountry = ({'Asia/Manila':'ph','Europe/Nicosia':'cy','Europe/London':'gb','America/New_York':'us','America/Los_Angeles':'us','Australia/Sydney':'au','America/Toronto':'ca'})[detectTimeZone()];
    const known = ['ph','cy','gb','us','au','ca','nz','sg','in','za','de','fr','es','it','nl','ie','pt','br','mx','ng','gh','ke','jp','kr','ae','sa'];
    const initial = known.includes(languageRegion) ? languageRegion : (tzCountry || 'us');
    phoneInputs.forEach(input => {
      if (input._fxpIti) return;
      try {
        input._fxpIti = window.intlTelInput(input, {
          initialCountry: initial,
          preferredCountries: ['ph','gb','us','au','ca','cy'],
          separateDialCode: true,
          nationalMode: false,
          formatAsYouType: true,
          countrySearch: true,
          dropdownContainer: document.body,
          fixDropdownWidth: false,
          useFullscreenPopup: false,
          loadUtils: () => import('https://cdn.jsdelivr.net/npm/intl-tel-input@25.12.3/build/js/utils.js')
        });
      } catch (_) { /* Fall back to manually entered E.164 numbers if the CDN fails. */ }
      input.addEventListener('input', () => input.setCustomValidity(''));
      input.addEventListener('countrychange', () => input.setCustomValidity(''));
    });
    populateCountrySelects();
  }
  function whenPhoneLibraryReady() {
    if (typeof window.intlTelInput === 'function') { initializePhoneInputs(); return; }
    const scripts = Array.from(document.scripts);
    const vendorScript = scripts.find(script => script.src.includes('intl-tel-input@25.12.3/build/js/intlTelInput.min.js'));
    if (vendorScript) {
      vendorScript.addEventListener('load', initializePhoneInputs, { once: true });
      vendorScript.addEventListener('error', () => { /* A manual E.164 entry still works. */ }, { once: true });
    }
    window.addEventListener('load', initializePhoneInputs, { once: true });
  }
  populateCountrySelects();
  whenPhoneLibraryReady();

  root.querySelectorAll('[data-fxp-scroll]').forEach(link => {
    link.addEventListener('click', event => {
      const target = root.querySelector('[data-fxp-apply]');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      window.setTimeout(() => {
        const firstRole = roleInputs[0];
        if (firstRole) firstRole.focus({ preventScroll: true });
      }, 250);
    });
  });

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitButton.disabled) return;
    if (messageNode) { messageNode.hidden = true; messageNode.classList.remove('fxp-form-message--error'); }

    const role = selectedRole();
    if (!role) {
      if (roleError) roleError.hidden = false;
      roleInputs[0].focus();
      showMessage('Please choose whether you are the player or a parent.', 'error');
      return;
    }
    activateRole(role, false);

    const requiredControls = Array.from(form.querySelectorAll(':required')).filter(control => !control.closest('[hidden]'));
    for (const control of requiredControls) {
      if (!control.checkValidity()) {
        control.reportValidity();
        return;
      }
    }
    if (!attendanceInputs.some(input => input.checked)) {
      showMessage('Please choose one webinar attendance option.', 'error');
      attendanceInputs[0].focus();
      return;
    }
    if (!workerUrl || !/^https:\/\//i.test(workerUrl) || workerUrl.includes('YOUR-WORKER')) {
      showMessage('The registration form is not connected yet. Please contact the site administrator.', 'error');
      return;
    }

    const attendance = attendanceInputs.find(input => input.checked).value;
    const payload = {
      parent_name: '', parent_email: '', parent_phone_number: '',
      first_name: form.querySelector('[name="first_name"]').value.trim(), last_name: form.querySelector('[name="last_name"]').value.trim(), email: form.querySelector('[name="email"]').value.trim(), phone: '',
      player_age: form.querySelector('[name="player_age"]').value.trim(), country_based: form.querySelector('[name="country_based"]').value.trim(), list_of_passports: form.querySelector('[name="list_of_passports"]').value.trim(), playing_level_information: form.querySelector('[name="playing_level_information"]').value.trim(), video_link: form.querySelector('[name="video_link"]').value.trim(), main_barrier: form.querySelector('[name="main_barrier"]').value.trim(), webinar_comment: form.querySelector('[name="webinar_comment"]').value.trim(),
      
      timezone_webinar: activeZone || 'Europe/Nicosia', selected_webinar_schedule: selectedWebinarSchedule(), webinar_attendance: attendance, contact_consent: Boolean(consentInput && consentInput.checked) ? 'Yes' : '', utm_date_added: new Date().toISOString().slice(0, 10), utm_source: 'Webinar'
    };
    if (role === 'parent') {
      const parentPhoneInput = form.querySelector('[name="parent_phone_number"]');
      payload.parent_name = form.querySelector('[name="parent_name"]').value.trim(); payload.parent_email = form.querySelector('[name="parent_email"]').value.trim(); payload.parent_phone_number = await normalizePhone(parentPhoneInput);
      if (!payload.parent_phone_number) { parentPhoneInput.reportValidity(); return; }
    }
    const playerPhoneInput = form.querySelector('[name="phone"]');
    payload.phone = await normalizePhone(playerPhoneInput);
    if (!payload.phone) { playerPhoneInput.reportValidity(); return; }

    submitButton.disabled = true;
    const originalButtonText = submitButton.innerHTML;
    submitButton.textContent = 'Submitting…';
    showMessage('Submitting your application securely…', 'pending');
    try {
      const response = await fetch(workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit'
      });
      let result = {};
      try { result = await response.json(); } catch (_) {}
      if (!response.ok) {
        throw new Error(result.message || 'We could not submit your application. Please check your details and try again.');
      }
      showMessage('Thanks. Here is what happens next. We review every application, and approved players get their link by email and WhatsApp.', 'success');
      form.querySelectorAll('input, textarea, select, button').forEach(control => { control.disabled = true; });
      form.querySelectorAll('.fxp-role-fields').forEach(fieldset => { fieldset.hidden = true; });
      if (successRedirectUrl) {
        try {
          const destination = new URL(successRedirectUrl, window.location.origin);
          if (destination.protocol === 'https:' || destination.protocol === 'http:') window.setTimeout(() => window.location.assign(destination.href), 450);
        } catch (_) { /* Keep the success state for an invalid configuration. */ }
      }
    } catch (error) {
      showMessage(error && error.message ? error.message : 'We could not submit your application. Please try again in a moment.', 'error');
      submitButton.disabled = false;
      submitButton.innerHTML = originalButtonText;
    }
  });
})();